export var CrmUsed = ['20CRM_Used', '20CRM_Used_5000', '21Q1CRM_Used_2000', '21Q2CRM_Used_2000', '21Q3CRM_Used_2000', '21Q4CRM_Used_2000', '22Q1CRM_Used_2000'];
